import api from "./Base";
import IntegrationType from "../types/integration/IntegrationType";
import EmailService from "../types/integration/EmailService";
import { showError } from '../utils/showAlert';
import { isProfileParameter } from "../helpers/notificationIntegrations";

const IntegrationsApi = {
    getIntegrationData:async (name: string) => {
        let url = `/parameter?name=${name}.%25`;
        let data: IntegrationType[] = [];

        await api.get<IntegrationType[]>(url)
            .then((response) => {
                data = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve pager duty data.', error);
                showError('Failed to retrieve pager duty data', error.message || error.toString());
            });
        return data;
    },

    getEmailIntegration:async (name: string) => {
        let url = `/parameter?name=${name}.%25`;
        let emailIntegrationData: EmailService[] = [];

        await api.get<EmailService[]>(url)
            .then((response) => {
                emailIntegrationData = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve email service data.', error);
                showError('Failed to retrieve email service data', error.message || error.toString());
            });
        return emailIntegrationData;
    },

    testEmailIntegration: async (params: { name: string; value: string; encrypted?: boolean }[]) => {
        await api.post('/integration/test/email', params);
    },

    testPagerDutyIntegration: async (params: { name: string; value: string }[]) => {
        await api.post('/integration/test/pagerduty', params);
    },

    testServiceNowIntegration: async (params: { name: string; value: string }[]) => {
        await api.post('/integration/test/servicenow', params);
    },

    testSlackIntegration: async (params: { name: string; value: string }[]) => {
        await api.post('/integration/test/slack', params);
    },

    testWebhookIntegration: async (params: { name: string; value: string }[]) => {
        await api.post('/integration/test/webhook', params);
    },

    getNotificationIntegrationData:async (basePrefix: string) => {
        let url = `/parameter`;
        let data: IntegrationType[] = [];

        await api.get<IntegrationType[]>(url)
            .then((response) => {
                data = response.data.filter(parameter => isProfileParameter(parameter.name, basePrefix));
            })
            .catch((error: any) => {
                console.error('Failed to retrieve integration data.', error);
                showError('Failed to retrieve integration data', error.message || error.toString());
            });
        return data;
    },
}

export default IntegrationsApi;
